import React, { useState, useCallback } from 'react';
import heroImage from '../assets/Hero-landing1.png';
import bubblesImage from '../assets/bubbles.png';
import thumbsUpImage from '../assets/Thumbsup.png';
import peopleImage from '../assets/People.png';
import huellaImage from '../assets/huella.png';
import direccionImage from '../assets/direccion.png';
import EstudiantesImage from '../assets/EstudiantesNEW.png';
import PersonasImage from '../assets/PersonasNEW.png';
import TrabajadoresEmprendedoresImage from '../assets/TrabajadoresEmprendedoresNEW.png';
import personasSituacionDesempleoImage from '../assets/PersonasSituacionDesempleoNEW.png';
import PersonasTrabajando from '../assets/PersonasTrabajando2.png'
import tiposCredencialesImage from '../assets/tipos_credenciales.png';
import arrowRightImage from '../assets/arrow-small-right.png';
import NavigationBar from './NavigationBar';
import LoginModal from './LoginModal';
import { Button } from 'react-bootstrap';
import { width } from '@fortawesome/free-regular-svg-icons/faAddressBook';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faArrowUpRightFromSquare,faLink} from '@fortawesome/free-solid-svg-icons';
import CaracteristicasMicro from '../assets/CaracteristicasMicro.jpeg';
import NewCaracteristicasMicro from '../assets/NewCaracteristicasMicro.png'

const Home = () => {
    const [modalShow, setModalShow] = useState(false);

    const handleHide = useCallback(() => {
        // logic to handle the hide
        setModalShow(false)
    }, []);

    return (
        <div>

            <NavigationBar />

            <main>
                <section className="container col-md-12">
                    

                    <div className="hero">
                        <img src={heroImage} id="img1" alt="" />
                        <div className="hero-content">
                      
                            <h1>Microcredenciales<br></br><span style={{ color: '#F20A61' }}>MacroImpacto</span></h1>
                            
                            
                            <p style = {{ fontSize: "18px"}} className="mb-4">
                                Las microcredenciales buscan flexibilizar, favorecer el acceso y ampliar 
                                la participación en la educación superior de todas las personas que buscan 
                                acortar las brechas de habilidades en el mercado laboral y mejorar su 
                                empleabilidad a través de la actualización o el desarrollo de competencias 
                                profesionales.
                            </p>
                            <p style = {{ fontSize: "18px"}} className="mb-4">
                                En la UAI, las microcredenciales siguen los mismos estándares de calidad 
                                de toda su oferta académica con propuestas formativas enfocadas en los 
                                estudiantes y el logro de resultados de aprendizaje que se hacen evidentes 
                                a través de sistemas de evaluación robustos y transparentes.
                            </p>

                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column', 
                                    alignItems: 'flex-start',
                                    marginTop: '1px',
                                    marginRight: '5px',
                                    padding: '0px 15px',
                                }}
                                >
                                <div
                                    style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginBottom: '30px',
                                    }}
                                >
                                    <span
                                    style={{
                                        marginRight: '10px',
                                        color: '#F20A61',
                                    }}
                                    >
                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                                    </span>
                                    <a
                                    href="https://uai.edu.ar/media/135686/orientaciones-para-la-presentaci%C3%B3n-y-dise%C3%B1o-de-microcredenciales-2-1.pdf"
                                    style={{
                                        color: '#F20A61',
                                        textDecoration: 'underline',
                                        fontSize: '26px',
                                        lineHeight: '1.2',
                                    }}
                                    >
                                    Orientaciones para la implementación y el diseño de microcredenciales
                                    </a>
                                </div>

                                <div
                                    style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    }}
                                >
                                    <span
                                    style={{
                                        marginRight: '10px',
                                        color: '#F20A61',
                                    }}
                                    >
                                    <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                                    </span>
                                    <a
                                    href="https://advance.uai.edu.ar/"
                                    style={{
                                        color: '#F20A61',
                                        textDecoration: 'underline',
                                        fontSize: '26px',
                                        lineHeight: '1.2',
                                    }}
                                    >
                                    Visitá nuestro catálogo en UAI Advance
                                    </a>
                                </div>
                                </div>
                            
                          
                        </div>
                    </div>
                </section>
                
                            <section className="container">
            <h3 className="texto_credencialesh3">
                Todas nuestras microcredenciales otorgan créditos académicos para carreras de grado, pregrado o posgrado
            </h3>
            <div className="huella col-md-12" style={{ marginTop: "0%" }}>
                <img src={tiposCredencialesImage} id="img2" alt="" />
                <p style={{  }}>
                <span style={{ color: "rgb(242, 10, 97)" }}>TIPOS DE CREDENCIALES</span>
                </p>
            </div>
            <div className="credenciales col-md-12">
                <div className="detalle_credencial">
                <div className="numero_credenciales">01</div>
                <div className="benefit_content">
                    <h3>Modulares</h3>
                    <p>
                        Programas cortos conformados por módulos que pueden combinarse para acceder a otra credencial.
                    </p>
                </div>
                </div>
                <div className="detalle_credencial">
                <div className="numero_credenciales">02</div>
                <div className="benefit_content">
                    <h3>Independientes</h3>
                    <p>
                        Cursos independientes que responden a necesidades específicas del sector social y productivo.
                    </p>
                </div>
                </div>
            </div>
            </section>


               
                <section>
                    <div className="container">
                        <div className="direccion">
                            <h1>Microcredenciales <br></br>Grandes oportunidades<br></br><span style={{ color: '#F20A61' }}>¿A quiénes va dirigido?</span></h1>
                            <img src={direccionImage} alt="" />
                        </div>
                        <div className="tarjetas">
                            <div className="tarjeta">
                                <img src={EstudiantesImage} alt="" />
                                <p style={{ textAlign: 'center' }}><strong>Estudiantes</strong> <hr></hr><span className='Tarjeta-Text'>Que busquen potenciar y visibilizar sus competencias profesionales.</span></p>
                            </div>
                            <div className="tarjeta space">
                                <img style={{  }}width="200" height="190" src={PersonasTrabajando} alt="" />
                                <p style={{ textAlign: 'center' }}><strong>Trabajadores y emprendedores</strong> <hr></hr><span className='Tarjeta-Text'>Que quieran actualizar y perfeccionar sus competencias y habilidades para mejorar su empleabilidad.</span></p>
                            </div>
                            <div className="tarjeta">
                                <img src={personasSituacionDesempleoImage} alt="" />
                                <p style={{ textAlign: 'center' }}><strong>Personas</strong> <hr></hr><span className='Tarjeta-Text'>Interesadas en potenciar su desarrollo personal, social o mejorar su empleabilidad en cualquier etapa de la vida.</span></p>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container">
                        <div className="direccion">
                            <h1 id='Texteh1'>Una oportunidad para desarrollar, mejorar, certificar y visibilizar habilidades y competencias.<br></br>
                            <span className="highlighted"> Características del diseño de los programas y cursos que otorgan microcredenciales</span>
                            </h1>
                            
                             <img 
                               src={NewCaracteristicasMicro}
                               alt="Descripción de la imagen"
                               style={{borderRadius: '83px 185px 95px 136px'}}
                               />
                           
                        </div>
                    </div>
                </section>
                <section className="container">
                    <div className="huella" id='LastCont'>
                        <img src={huellaImage} id='img3' alt="" />
                        <p>Sumate a las nuevas tendencias en educación<span style={{ color: '#F20A61' }}></span></p>
                    </div>
                </section>
            </main>
            <LoginModal show={modalShow} onHide={handleHide} />
        </div>
    );
};

export default Home;
